(function () {
    'use strict';

    angular
        .module('app.gameTracker')
        .component('sc3GameTracker', {
            templateUrl: 'app/game-tracker/game-tracker.component.html',
            controller: GameTrackerComponent,
            bindings: {
                individualId: '<',
                courseId: '<',
                category: '<',
                range: '<',
                courseList: '<'
            }
        });

    var gettext = angular.identity;

    GameTrackerComponent.$inject = ['$state', 'gameTrackCategory', 'gameTrackRange'];
    function GameTrackerComponent($state, gameTrackCategory, gameTrackRange) {
        var ctrl = this;

        // properties
        ctrl.individualId = null;
        ctrl.courseId = null;
        ctrl.category = null;
        ctrl.range = null;

        // list properties
        ctrl.courseList = null;
        ctrl.categoryEnum = gameTrackCategory;
        ctrl.rangeEnum = gameTrackRange;

        // methods
        ctrl.$onInit = init;
        ctrl.onChange = onChange;

        /////////////////////////////////////
        function init() {
            ctrl.category = Object.values(gameTrackCategory.$metadata).find(find).value;

            function find(metadata) {
                return metadata.state === $state.current.name;
            }
        }

        function onChange() {
            var state = gameTrackCategory.$metadata[ctrl.category].state;

            $state.go(state, {
                individualId: ctrl.individualId,
                courseId: ctrl.courseId,
                range: ctrl.range,
                courseList: ctrl.courseList // preserve list to prevent calling over and over
            });
        }
    }
})();